import { Component, Input, ViewEncapsulation } from "@angular/core";
import { ITestimony } from "./testimony";
import { getStorageLanguage, LANGUAGES } from "../extra";

@Component({
  selector: "bvl-testimony",
  templateUrl: "./testimony.component.html",
  styleUrls: ["./testimony.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class TestimonyComponent {
  open = false
  TEXT = LANGUAGES[getStorageLanguage()];

  @Input() testimony: ITestimony;


}
